<template>
    <FormulateInput
      type="radio"
      :label="label"
      :options="options"
      :validation="validation"
      @blur-context="inputCallback"
      v-model="value"
      @validation="$emit('validation', $event)"
      v-bind="$attrs"
    />
</template>
<script>

export default {
  name:'FormRadioInputComponent',
  props: {
    value: {}
  },
  data() {
    return {
        props:{}
    }  
  },

  methods: {
    inputCallback(value){
      this.$emit('update', value)
    }
  }
}
</script>